import React, { useState } from "react";
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const rows = [
  { slNo: 1, isurl: true, description: "Latest Order - Delegation of Power under TCP Act,1977 to Executive Officers/Secretaries of Urban Local Bodies", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Department_notification.pdf" },
  { slNo: 2, isurl: false, description: "Delegation of powers under TCP Act", pdfUrl: "edd56c3d-051c-473d-be10-8eede0c53fc2" },
  { slNo: 3, isurl: true, description: "Dealing of cases for Regularization of Deviations and Un-authorised Constructions under Section 30-B of the Uttar Pradesh Town and Country Planning (Amendment) Ordinance,2016( Ordinance No. 1 of 2016)", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_section_30_B_to_.pdf" },
  { slNo: 4, isurl: true, description: "Delegation of Power under TCP Act,1977 to Commissioner,M.C Dharamshala", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_power_MC_Dharamshal.pdf" },
  { slNo: 5, isurl: true, description: "Deligation of Power under section 30-B of Uttar Pradesh Town and country Planning (Amendment)Act,2016(Act No. of 2017)", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_power.pdf" },
  { slNo: 6, isurl: true, description: "Competent Authority of dealing cases under Section 30-B of the Uttar Pradesh Town and Country Planning (Amendment) Act,2016(Act No.1 of 2017)", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/compitent_Authority.pdf" },
  { slNo: 7, isurl: true, description: "Delegation of  power to ULBs under Single Window System.", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_Power_14-05-2017.pdf" },
  { slNo: 8, isurl: false, description: " Delegation of power in respect of Flatted/Plotted Colonies or Real Estate Projects", pdfUrl: "2113fc56-c40c-4846-98a7-c4238b92af2c" },
  { slNo: 9, isurl: false, description: "Delegation of Power to 20 constituted as planning area.(2018).", pdfUrl: "3bf55142-2381-4256-8449-75a447d93be9" },
  { slNo: 10, isurl: false, description: "Delegation of Power to Enforcement Wing.", pdfUrl: "23ee2fed-435a-432e-9d33-5550856f97c3" },
  { slNo: 11, isurl: false, description: "Delegation of Power to BBNDA.", pdfUrl: "487b19f8-6a5b-491e-b297-700bc8950278" },
  { slNo: 12, isurl: false, description: "Delegation of Power for new MC Solan, MC Palampur & MC Mandi.", pdfUrl: "f071f6d5-f6c5-4ff0-a0f3-dfaaf9c59788" },

];

const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const PowerDelegation = () => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return (
    <TableContainer component={Paper}>
      <Typography variant='h6' style={{margin: '20px'}}>
        Delegation of Powers
      </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <TableRow style={{background: '#1F4A7C', height: '20px'}}>
            <TableCell style={{width: '5%', color: 'white'}}>SL. No</TableCell>
            <TableCell style={{width: '75%', color: 'white'}}>Description</TableCell>
            <TableCell style={{width: '5%', color: 'white'}}>PDF</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.slNo}>
              <TableCell component="th" scope="row">
                {row.slNo}
              </TableCell>
              <TableCell>{row.description}</TableCell>
              <TableCell onClick={() => row.isurl ? handlePdfDownload(row.pdfUrl) : getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#1F4A7C'}}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PowerDelegation;
